import { TStepperStepStatus } from 'shared/components/stepper/models'

import { TWizardStep } from '../models'

interface IGetStepperConfigParams {
  steps: TWizardStep[]
  currentStepIndex: number
  isFreeMode?: boolean
}

export const getStepperConfig = ({
  steps,
  currentStepIndex,
  isFreeMode,
}: IGetStepperConfigParams) =>
  steps.map((step, index) => {
    let status: TStepperStepStatus = 'incomplete'

    const isStepCurrent = index === currentStepIndex
    const isStepCompleted = index < currentStepIndex

    if (isStepCurrent) {
      status = 'current'
    }

    if (isStepCompleted && !steps[index + 1]?.isBackStepDisabled) {
      status = 'complete'
    }

    if (index > currentStepIndex || (isStepCompleted && steps[index + 1]?.isBackStepDisabled)) {
      status = 'disabled'
    }

    if (step.status) {
      status = step.status
    }

    if (isFreeMode) {
      status = 'complete'
    }

    return {
      label: step.title,
      description: step.description,
      step: index + 1,
      status: status,
    }
  })
